import { CHANGE_CONNEXION, CHANGE_CATEGORIES, CHANGE_FOODS, CHANGE_ALLERGENS, CHANGE_IMAGES, CHANGE_COUNT, CHANGE_POPUPC, CHANGE_POPUPS } from "../actions/action-types";
import Login from '../components/Login'
import React from 'react';

const initialState = {
  categories:[],
  foods:[],
  allergens:[],
  images:[],
  count:[],
  connexion: <Login  key={"login"} />,
  style_popup:{display:"none"},
  text_popup:""
};

function rootReducer(state = initialState, action) {  

  if (action.type === CHANGE_COUNT) {
    return Object.assign({}, state, {
      count: action.payload
    });
  }

  if (action.type === CHANGE_POPUPS) {
    return Object.assign({}, state, {
      style_popup: action.payload
    });
  }

  if (action.type === CHANGE_POPUPC) {
    return Object.assign({}, state, {
      text_popup: action.payload
    });
  }

  if (action.type === CHANGE_CONNEXION) {
    return Object.assign({}, state, {
      connexion: action.payload
    });
  }

  if (action.type === CHANGE_CATEGORIES) {
    return Object.assign({}, state, {
      categories: action.payload
    });
  }

  if (action.type === CHANGE_FOODS) {
    return Object.assign({}, state, {
      foods: action.payload
    });
  }

  if (action.type === CHANGE_ALLERGENS) {
    return Object.assign({}, state, {
      allergens: action.payload
    });
  }

  if (action.type === CHANGE_IMAGES) {
    return Object.assign({}, state, {
      images: action.payload
    });
  }

  return state;
}
export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js